import { extendTailwindMerge } from "tailwind-merge"

type ClassValue = string | false | null | undefined

// Teach tailwind-merge the custom theme keys from styles.css so later classes win, e.g.
// <Button className="h-[50px] rounded-card"> overrides the size's height and radius.
const merge = extendTailwindMerge({
  extend: {
    theme: {
      radius: ["control", "card"],
      shadow: ["tab", "raise", "focus-node", "sheet"],
    },
  },
})

/** Joins class names, skipping falsy values; conflicting Tailwind classes resolve to the last one. */
export const cn = (...classes: ClassValue[]): string => merge(classes.filter(Boolean).join(" "))
